import breadcrumbs from "@/views/modules/ApplicationBudgets/MenuList.vue";
import lang from "@/views/modules/ApplicationBudgets/language/en";
import tinymce from 'vue-tinymce-text-editor';
import DateFormat from "@/plugins/date_format.js";
import loader from "@/views/shared/loading/Loading.vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import alert from "@/views/shared/notify/Alert.vue";

export default {
    name: "detail-applicationbudgets",

    components: {
        breadcrumbs,
        loader,
        vSelect,
        'tinymce': tinymce,
        alert,
    },
    data() {
        return {
            loading: true,
            budgetHead: [],
            budgetItem: [],
            tdYear: 1,
            year1: true,
            year2: false,
            year3: false,
            year4: false,
            year5: false,
            year6: false,
            year7: false,
            year8: false,
            year9: false,
            year10: false,
            templateData: [],
            lang: [],
            leftLoading: false,
            rightLoading: false,
            totalInr: 0,
            multiplier:'',
            other_currency:0,
            app_budget_id: '',
            commentsList: [],
            activitiesList: [],
            activitiesListitems: [],
            customLoading: false,
            comment: '',
            taggedUser: [],
            usersList: [],
            current_url:'',
            templateName:'export',
        }
    },
    mounted() {
        this.getUserList();
        this.getApplicationTemplate();
        this.loadComments();
        this.updateNotification();
        this.lang = lang;
        this.current_url = window.location.origin;
        this.current_url.slice(0, -1);
    },

    methods: {
        updateNotification() {
            const self = this;
            self.loading = true;
            let postData = {
                parent_id:self.$route.params.id,
                parent_type:'ApplicationBudgets',
            }
            axios.post('api/modules/notifications/read-notification', postData).then(function (response) {
                self.loading = false;
            }).catch(function () {
                self.loading = false;
            });
        },
        getUserList() {
            const self = this;
            axios.post('api/modules/users/select').then(function (response) {
                self.usersList = response.data.items;

                self.usersList = response.data.items.map(item => ({
                    id: item.id,
                    name: item.name,
                    dname: `${item.name} (${item.email})`,
                }));

            })
        },
        getApplicationTemplate() {
            const self = this;
            self.loading = true;
            window.currentAction = 'list';
                axios.get('api/modules/get_template', { params: { 'template_id': self.$route.params.id } }).then(function (response) {

                if (response.data.message) {
                    
                    self.$refs.notifyMsg.showAlert('Success',response.data.message);
                }

                self.tdYear = response.data.app_template[0].template_year;

                if (self.tdYear == 2) {
                    self.year2 = true;
                }
                if (self.tdYear == 3) {
                    self.year2 = true;
                    self.year3 = true;
                }
                if (self.tdYear == 4) {
                    self.year2 = true;
                    self.year3 = true;
                    self.year4 = true;
                }
                if (self.tdYear == 5) {
                    self.year2 = true;
                    self.year3 = true;
                    self.year4 = true;
                    self.year5 = true;
                }
                if (self.tdYear == 6) {
                    self.year2 = true;
                    self.year3 = true;
                    self.year4 = true;
                    self.year5 = true;
                    self.year6 = true;
                }
                if (self.tdYear == 7) {
                    self.year2 = true;
                    self.year3 = true;
                    self.year4 = true;
                    self.year5 = true;
                    self.year6 = true;
                    self.year7 = true;
                }
                if (self.tdYear == 8) {
                    self.year2 = true;
                    self.year3 = true;
                    self.year4 = true;
                    self.year5 = true;
                    self.year6 = true;
                    self.year7 = true;
                    self.year8 = true;
                }
                if (self.tdYear == 9) {
                    self.year2 = true;
                    self.year3 = true;
                    self.year4 = true;
                    self.year5 = true;
                    self.year6 = true;
                    self.year7 = true;
                    self.year8 = true;
                    self.year9 = true;
                }
                if (self.tdYear == 10) {
                    self.year2 = true;
                    self.year3 = true;
                    self.year4 = true;
                    self.year5 = true;
                    self.year6 = true;
                    self.year7 = true;
                    self.year8 = true;
                    self.year9 = true;
                    self.year10 = true;
                }

                self.budgetHead = response.data.data1;
                self.budgetItem = response.data.data2;
                self.templateData = response.data.app_template[0];
                self.templateName = self.templateData.application_title+'_'+self.templateData.app_owner;
                self.multiplier = response.data.app_template.currency_multiplier;
                self.leftLoading = false;
                self.rightLoading = false;
                
                self.calculateGrandTotal(self.$route.params.id);

                if(self.templateData.app_budget_status != 'Pending')
                {
                    document.getElementById("approvedBudgetBtn").style.display = "none";
                }

                self.loading = false;
            }).catch(function () {
                self.loading = false;
            });
        },
        calculateGrandTotal(app_template_id) {
            const self = this;
            let totalinr = 0;
            let otherCurrency  = 0;

            axios.post('api/modules/gettotalinrapp', { 'app_temp_id': app_template_id }).then(function (response) {

                if (response.data.total_inr > 0) {
                    totalinr = response.data.total_inr;
                }
                self.totalInr = totalinr;

                if(totalinr > 0){
                    otherCurrency = parseFloat(totalinr / self.multiplier).toFixed(2);
                }
                self.other_currency = otherCurrency;

            })
        },
        GetDisplayDate(date = '') {
            if (date != '') {
                const date_format = new DateFormat("dd/MM/yyyy");
                return date_format.changeDateFormat(date);
            }

        },

        loadComments() {
            const self = this;
            let searches = {
                'parent_type': 'ApplicationBudgets',
                'parent_id': self.$route.params.id,
            }
            self.customLoading = 'comment';
            window.currentAction = 'list';
                axios.get('api/modules/comments', { params: { search: searches, perPage: '999999999999' } }).then(function (response) {
                self.commentsList = response.data.items.reverse();
                self.customLoading = false;
            })
        },
        loadActivities() {
            const self = this;
            let searches = {
                'parent_type': 'ApplicationBudgets',
                'parent_id': self.$route.params.id,
            }
            self.customLoading = 'activity';
            window.currentAction = 'list';
                axios.get('api/modules/comments', { params: { search: searches, perPage: '999999999999' } }).then(function (response) {
                var activitiesListData = {};
                const activitiesListitems = response.data.items;
                activitiesListitems.forEach(entry => {
                    const date = self.extractDate(entry.date_entered);
                    if (activitiesListData[date]) {
                        activitiesListData[date].push(entry);
                    } else {
                        activitiesListData[date] = [entry];
                    }
                });
                self.customLoading = false;
                self.activitiesList = activitiesListData;
            })
        },
        extractDate(dateString) {
            const dateObj = moment(dateString, 'DD/MM/YYYY h:mma');
            const formattedDate = dateObj.format('DD/MM/YYYY');
            return formattedDate;
        },
        addComments() {
            const self = this;
            let formData = {
                'parent_type': 'ApplicationBudgets',
                'parent_id': self.$route.params.id,
                'description': self.comment,
                'taggedUser': self.taggedUser,
            }
            if (self.comment === '') {
                
                self.$refs.notifyMsg.showAlert('Error','comment can not be empty');
                return false;
            }
            self.customLoading = 'addComment';
            axios.post('api/modules/comments', formData).then(function (response) {
                self.loadComments();
                self.comment = '';
                self.taggedUser = [];
                document.getElementById("comment").value = '';
                self.customLoading = false;
            })
        },
        exportcsv(){
            const self = this;
            axios.post('api/modules/exportappbudget', { 'app_temp_id': self.$route.params.id, 'language':self.lang}).then(function (response) {
                //console.log(response.data);
                let jsonData = response.data;
                //console.log(self.templateName);
                var blob = new Blob([jsonData]);
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                
                let filename = self.templateName;
                link.download = filename+'.csv';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            })
        },
        approvedAppBudget(){
            const self = this;
            if(self.templateData.app_budget_status)
            {
                axios.post('api/modules/approvebudget', {'app_temp_id':self.$route.params.id, 'app_budget_status':'Approved'}).then(function (response) {
                    document.getElementById("approvedBudgetBtn").style.display = "none";
                })
            }else{
                document.getElementById("approvedBudgetBtn").style.display = "none";
            }
        },
        downloadPrivate(doc_id, tbl,filename) {
            const self = this;
            const token = localStorage.getItem('token');
            if (!token) {
                alert('Please login to download files');
                return;
            }
            
            axios.get(`api/modules/download/${doc_id}/${tbl}`, {
                responseType: 'blob',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then((response) => {
                //console.log(response);
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            }).catch((error) => {
                console.error('Download failed:', error);
                self.$refs.notifyMsg.showAlert('Error', 'Download failed. File may not exist or access denied.');
            });
        }
    }
}